import { Grid, Typography } from '@mui/material';

import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

export const ExplanatoryLegend = () => {
  const { t } = useTranslation();
  return (
    <Grid container alignItems={'center'} gap={2}>
      <div className="previewTab__explanatory-legend__icon" />
      <Typography className="previewTab__explanatory-legend__description">
        {t(translations.pages.moduleSelectionsDetail.modulePreview.explanatoryLegendText())}
      </Typography>
    </Grid>
  );
};
